import { MotiView } from "moti";
import React from "react";

import {
  Box,
  Pressable,
  PressableProps,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type UnderlinedTabItemProps = {
  customComponentOrTitle: React.ReactElement | string;
  index: number;
  currentIndex: number;
  setIndex: (value: number) => void;
  tabStyle?: Omit<PressableProps, "children">;
};

export const UnderlinedTabItem = ({
  setIndex,
  index,
  currentIndex,
  customComponentOrTitle,
  tabStyle,
}: UnderlinedTabItemProps) => {
  const active = currentIndex === index;

  return (
    <Pressable
      py={2}
      flex={1}
      justifyContent="center"
      alignItems="center"
      flexDirection="row"
      onPress={() => setIndex(index)}
      testID={`set-index-pressable-${index}`}
      position="relative"
      flexShrink={1}
      {...tabStyle}
    >
      {typeof customComponentOrTitle === "string" ? (
        <Text
          maxFontSizeMultiplier={2}
          textAlign="center"
          style={{ zIndex: 2 }}
          variant={active ? "mainBaseSemiBold" : "mainBaseMedium"}
          color={active ? "text-primary" : "text-secondary"}
        >
          {customComponentOrTitle}
        </Text>
      ) : (
        customComponentOrTitle
      )}
      <MotiView
        pointerEvents="none"
        from={{ opacity: 0 }}
        animate={{ opacity: active ? 1 : 0 }}
        transition={{
          opacity: {
            type: "timing",
            duration: 250,
          },
        }}
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Box
          position="absolute"
          right={0}
          left={0}
          bottom={-1}
          width="100%"
          alignItems="center"
        >
          <Box bg="main-primary-500" width="100%" height={2} />
        </Box>
      </MotiView>
    </Pressable>
  );
};
